import React from "react";
import { useMediaQuery } from "@mui/material";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

import { QUIZ_LENGTH } from "../../..";

export const AnimalRadarChart = ({ results, graphColour }) => {
  const isMobile = useMediaQuery(
    `(max-width:${localStorage.getItem("SM_SCREEN")})`
  );

  return (
    <ResponsiveContainer width={"100%"} height={isMobile ? 200 : 350}>
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={results}>
        <PolarGrid />
        <PolarAngleAxis dataKey="area" tick={{ fontSize: 15 }} />
        {!isMobile && (
          <PolarRadiusAxis
            tick={{ fontSize: 11, fill: "rgb(102, 102, 102)" }}
            domain={[0, QUIZ_LENGTH * (2 / 3)]}
          />
        )}
        <Radar
          name="Results"
          dataKey="score"
          stroke={graphColour}
          fill={graphColour}
          fillOpacity={0.4}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default AnimalRadarChart;
